export function handleSortableLists(selector) {
	if (typeof selector === 'object') {
		var $cont = selector.find('[sortable-container]');
	} else {
		var $cont = $(selector + ' [sortable-container]');
	}

	$cont.each(function (idx) {
		let $sortableContainer = $(this);
		sortableLists($sortableContainer, $sortableContainer.data('url'))
	});
}

export function sortableLists($selector, baseUrl) {
	$selector.sortable({
		handle: ".fa-arrows",
		update: function (event, ui) {

			let $el = $(this);
			var newOrderForItems = $el.sortable("toArray", {
				attribute: "data-pk"
			});

			najaGlobal.makeRequest('POST', baseUrl, { orderedItemsId: newOrderForItems }).then((payload) => {
				if (payload.result) {
					staticNotification.success('Pořadí úspěšně uloženo.');
				} else {
					staticNotification.error(payload.errorMessage);
				}
			});
		}
	}).disableSelection();
}

window.sortableLists = sortableLists
